import { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./common/Header";
import Sidebar from "./common/Sidebar";

export default function Layout() {
  const [activeSidebar, setActiveSidebar] = useState(true);

  const handleToggle = () => {
    setActiveSidebar(!activeSidebar);
  };

  return (
    <div className="bg-[#e5eff9] h-screen flex flex-col overflow-hidden">
      <div className="shrink-0 sticky top-0 z-10 shadow-sm">
        <Header handleToggle={handleToggle} activeSidebar={activeSidebar} />
      </div>

      <div className="flex flex-1 overflow-hidden">
        <div
          className={`${
            activeSidebar ? "w-64" : "w-0"
          } border-r border-[#D9D9D9] overflow-y-auto overflow-x-hidden no-scrollbar transition-all duration-300`}
        >
          <Sidebar />
        </div>

        <div className="flex-1 overflow-y-auto p-6 no-scrollbar">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
